import { useFormContext } from 'react-hook-form';
import { getJobTitles, IJobSuggestions } from 'wisestep-api';

import { WsAsyncAutocomplete } from '../../../components/WsAsyncAutocomplete';
import { getJobTitlesWithCodes } from '../../../features/jobs/helper/jobsFiltersHelper';

interface IJobTitleFilterNew {
  name: string;
  placeholder: string;
  multiple: boolean;
  freeSolo: boolean;
  defaultValue?: IJobSuggestions[];
  reset?: boolean;
  required?: boolean;
  disable?: boolean;
}

const JobTitleFilterNew = ({
  name,
  placeholder,
  required = false,
  disable = false,
  multiple,
}: IJobTitleFilterNew) => {
  const methods = useFormContext();
  const onSearch = async (searchText: string) => {
    const response = await getJobTitles(searchText);
    if (response?.data) {
      const selected = methods.getValues(name) ?? [];
      const options = response.data
        .filter((job) => !selected.some((selectedJob) => selectedJob.id === job.id))
        .map((job) => ({
          ...job,
          label: getJobTitlesWithCodes(job),
        }));
      return options;
    }
    return [];
  };
  return (
    <WsAsyncAutocomplete
      name={name}
      getOptions={onSearch}
      multiple={multiple}
      placeholder={placeholder}
      creatable={false}
      onCreate={() => {}}
      required={required}
      disable={disable}
    />
  );
};

export default JobTitleFilterNew;
